'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userEditForm = require('./user-edit-form.html');

var _userEditForm2 = _interopRequireDefault(_userEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _userEditForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    accessLevels: '<',
    user: '<',
    showAccessLevel: '<',
    onUserChanged: '&'
  },
  controller: function () {
    function UserEditFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, UserEditFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(UserEditFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.user = this.user || {};
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onUserChanged(this.EventEmitter({
          user: this.user
        }));
      }
    }]);

    return UserEditFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/user-edit-form/user-edit-form.component.js